'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProductBadge({
  background,
  color,
  text,
  className,
}: {
  background: string;
  color: string;
  text: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'ea-product-badge',
        'flex h-[23px] items-center justify-center rounded-full px-3 text-xs font-semibold tracking-tight sm:text-xs',
        className,
      )}
      style={{ backgroundColor: background, color: color ?? '#ffffff' }}
    >
      {text}
    </div>
  );
}
